import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { Toolbar as Toolbar$1 } from '@mui/material';
import { createButton } from '../../factories/button/button.factory.js';
import '../LayoutGrid/LayoutGrid.js';
import '../Paper/Paper.js';
import '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import keygen from 'uuid/v4';
var _excluded = ["items", "sx"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var styles = {
  toolbarRoot: {
    '&[class*="MuiToolbar"]': {
      minHeight: 0
    },
    // remove padding from main toolbar container
    '&[class*="MuiToolbar-gutters"]': {
      paddingLeft: 0,
      paddingRight: 0
    },
    // remove double margin from adjacent buttons
    '&>.toolbar-actionGroup-left>button:not(:first-child)': {
      marginLeft: 0
    },
    '&>.toolbar-actionGroup-right>button:not(:first-child)': {
      marginLeft: 0
    },
    // remove margin from left and right toolbar groups
    '&>.toolbar-actionGroup-left>button:first-child': {
      marginLeft: 0
    },
    '&>.toolbar-actionGroup-right>button:last-child': {
      marginRight: 0
    }
  }
};

var buildLeftGroup = function buildLeftGroup(items) {
  var leftItems = items.filter(function (child) {
    return child.position === 'left';
  });

  if (leftItems.length === 0) {
    return [];
  }

  return leftItems.map(function (group) {
    var key = group.id ? group.id : keygen();
    /* istanbul ignore next */

    if (process.env.NODE_ENV !== 'production') {
      checkInvalidGroupId(group.id);
    }

    return /*#__PURE__*/React.createElement("div", {
      key: key,
      style: {
        flexGrow: 1,
        display: 'flex'
      },
      className: "toolbar-actionGroup-left"
    }, group.items.map(function (item, index) {
      /* istanbul ignore next */
      if (process.env.NODE_ENV !== 'production') {
        checkInvalidButtonId(item.id);
      }

      return createButton(_objectSpread({
        id: index
      }, item));
    }));
  });
};

var buildRightGroup = function buildRightGroup(items) {
  var rightItems = items.filter(function (child) {
    return child.position === 'right';
  });

  if (rightItems.length === 0) {
    return [];
  }

  return rightItems.map(function (group) {
    var key = group.id ? group.id : keygen();
    /* istanbul ignore next */

    if (process.env.NODE_ENV !== 'production') {
      checkInvalidGroupId(group.id);
    }

    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flexGrow: 1,
        display: 'flex'
      },
      key: keygen()
    }), /*#__PURE__*/React.createElement("div", {
      key: key,
      className: "toolbar-actionGroup-right"
    }, group.items.map(function (item, index) {
      /* istanbul ignore next */
      if (process.env.NODE_ENV !== 'production') {
        checkInvalidButtonId(item.id);
      }

      return createButton(_objectSpread({
        id: index
      }, item));
    })));
  });
};

var Toolbar = function Toolbar(_ref) {
  var items = _ref.items,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  var toolbarRoot = styles.toolbarRoot;
  return /*#__PURE__*/React.createElement(Toolbar$1, _extends({
    sx: [toolbarRoot, sx]
  }, rest), buildLeftGroup(items), buildRightGroup(items));
};

Toolbar.displayName = 'Toolbar';
/* Utilities */

var hasCheckInvalidGroupIdRun = false;
/* istanbul ignore next */

function checkInvalidGroupId(id) {
  if (id === undefined && !hasCheckInvalidGroupIdRun) {
    console.warn("Please make sure to pass an id to the toolbar group, otherwise the group will unmount / remount on every re-render instead of updating in place.");
    hasCheckInvalidGroupIdRun = true;
  }
}

var hasCheckInvalidButtonIdRun = false;
/* istanbul ignore next */

function checkInvalidButtonId(id) {
  if (id === undefined && !hasCheckInvalidButtonIdRun) {
    console.warn("If the order of the buttons change, please make sure to pass an id to each button, otherwise stale data may be passed to the button.");
    hasCheckInvalidButtonIdRun = true;
  }
}

export { Toolbar };